/* based on the stuff from platform plus vinovest funds */
export enum PaymentMethodType {
    Card = 'card',
    BankTransfer = 'ach',
    Crypto = 'crypto',
    WireTransfer = 'wire',
    VinovestFunds = 'vinovest_funds',
    Other = 'other' // for any other payment methods not explicitly defined
}

/** Payment metadata returned from the server */
export interface PaymentMethod {
    id: string;
    type: PaymentMethodType;
    name: string;
    lastFour: string;
    accountID: string;
    card: {
        brand: string;
        lastFour: string;
        countryCode: string;
    };
    bank: {
        lastFour: string;
        name: string;
    };
    ach: {
        name: string;
        lastFour: string;
    };
}
